import { Fragment, Children, type ReactNode } from 'react';

interface Props {
  caseId: number | string;
  children: ReactNode;
}

export function Switch(props: Props) {
  const { caseId, children } = props;
  return (
    <Fragment>
      {Children.map(children, (child: any) => 
        child.props.caseId === caseId
          ? child
          : null
      )}
    </Fragment>
  );
}
